import { Type } from "class-transformer";
import { Contact } from "../crm/contact.model";
import { ScheduledEmail } from "../scheduled-email/scheduled-email.model";
import { FormInstance } from "./form-instance.model";

/**
 * Type on contact on form instance
 */
export enum FormInstanceContactType {
  Recipient = "recipient",
  Subject = "subject",
  SMC = "smc",
}

export class FormInstanceContact extends Contact {
  uuid: string;
  type: FormInstanceContactType;
  @Type(() => Boolean)
  optedOut: boolean;
  @Type(() => Boolean)
  stopAutoEmails: boolean;
  @Type(() => Boolean)
  emailSent: boolean;
  @Type(() => FormInstance)
  formInstance: FormInstance;
  @Type(() => {
    // Lazy load to avoid circular reference
    const { ScheduledEmail } = require("../scheduled-email/scheduled-email.model");
    return ScheduledEmail;
  })
  scheduledEmails: ScheduledEmail[];

  get isSMC(): boolean {
    return this.type === FormInstanceContactType.SMC;
  }

  get isSubject(): boolean {
    return this.type === FormInstanceContactType.Subject;
  }

  get isRecipient(): boolean {
    return this.type === FormInstanceContactType.Recipient;
  }

  get pausedReminderEmails(): ScheduledEmail[] {
    return this.scheduledEmails.filter((scheduledEmail) => !!scheduledEmail.isPaused);
  }
}
